// src/icons/DollarManropeSmall.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function DollarManropeSmall({
  strokeWidth = "1.5",
  strokeLinecap = "round",
  strokeLinejoin = "round"
}) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10.0005 3.3291V1.84668M10.0005 16.6709V18.1533M13.5318 5.55273C12.8269 4.66654 11.5095 4.07031 10.0005 4.07031H9.54754C7.5462 4.07031 5.92383 5.25023 5.92383 6.70572V6.81886C5.92383 7.85997 6.7326 8.81163 8.01298 9.27722L11.9881 10.7227C13.2685 11.1883 14.0771 12.14 14.0771 13.1811C14.0771 14.699 12.3852 15.9296 10.2978 15.9296H10.0005C8.4915 15.9296 7.17414 15.3334 6.46921 14.4472",
          stroke: "currentColor",
          strokeWidth,
          strokeLinecap,
          strokeLinejoin
        }
      )
    }
  );
}

export {
  DollarManropeSmall
};
